import { Card, Button } from "antd";
import { CrownOutlined } from "@ant-design/icons";
import { useAuth } from "../../context/authContext";
import { useLanguage } from "../../context/LanguageContext";
import dashboardContent from "../../utils/dashboardContent";
import { useNavigate } from "react-router-dom";

const UpgradeCard = () => {
  const { subscriptionLevel } = useAuth();
  const { language } = useLanguage();
  const text = dashboardContent[language].upgradeCard;
  const navigate = useNavigate();

  return (
    <>
      {subscriptionLevel <= 3 && (
        <div className="lg:flex justify-center items-center bg-gray-100 mb-4 hidden">
          <Card
            className="w-80 shadow-lg transition-all duration-300 ease-in-out transform hover:-translate-y-1 hover:shadow-xl"
            bodyStyle={{ padding: "1.5rem" }}
          >
            <div className="text-center">
              <CrownOutlined className="text-4xl text-yellow-500 mb-4" />
              <h2 className="text-2xl font-bold mb-2">{text.title}</h2>
              <p className="text-gray-600 mb-6">{text.description}</p>
              <Button
                type="primary"
                size="large"
                onClick={() => navigate("/dashboard/abomanagement")}
                className="bg-gradient-to-r from-blue-500 to-purple-600 border-0 hover:from-blue-600 hover:to-purple-700"
                block
              >
                {text.upgradeButton}
              </Button>
            </div>
          </Card>
        </div>
      )}
    </>
  );
};

export default UpgradeCard;
